var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountMultiplePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "14px",
    viewBox: "0 0 24 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "account-multiple-plus") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "-1.1.-People_list",
    transform: "translate(-23.000000, -120.000000)",
    fill: "#71B8CB",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "account-multiple-plus",
    transform: "translate(23.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19,12 L19,14 L7,14 L7,12 C7,12 7,8 13,8 C19,8 19,12 19,12 M16,3 C16,1.34314575 14.6568542,0 13,0 C11.3431458,0 10,1.34314575 10,3 C10,4.65685425 11.3431458,6 13,6 C14.6568542,6 16,4.65685425 16,3 M19.2,8.06 C20.3042162,9.07871344 20.9527979,10.4983867 21,12 L21,14 L24,14 L24,12 C24,12 24,8.55 19.2,8.06 M18,0 C17.6978644,0.00018081326 17.3975999,0.047413429 17.11,0.14 C18.3083092,1.85838717 18.3083092,4.14161283 17.11,5.86 C17.3975999,5.95258657 17.6978644,5.99981919 18,6 C19.6568542,6 21,4.65685425 21,3 C21,1.34314575 19.6568542,0 18,0 M8,5 L5,5 L5,2 L3,2 L3,5 L0,5 L0,7 L3,7 L3,10 L5,10 L5,7 L8,7 L8,5 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountMultiplePlus);
export default __webpack_public_path__ + "static/media/account-multiple-plus.28eaa110cdad7a4e3237dafc877ac6b5.svg";
export { ForwardRef as ReactComponent };